import httpClient from '../../utils/httpClient';
import { ApiSuccessResponse } from '../../utils/apiSchemas';

const USER_ACCESS_BASE_ROUTE = '/api/v1/portal/enrollment';

export interface AccountConfirmationPayload {
  userAccessGuid: string;
  token: string;
}

export type AccountConfirmationResponse = boolean;

export const confirmUserAccessAccount = async (
  payload: AccountConfirmationPayload
): Promise<ApiSuccessResponse<AccountConfirmationResponse>> => {
  const response = await httpClient.post<ApiSuccessResponse<AccountConfirmationResponse>>(
    `${USER_ACCESS_BASE_ROUTE}/token/confirm-account`,
    payload
  );
  return response.data;
};

// Add resend token confirmation API client
export interface ResendTokenPayload {
  userAccessGuid: string;
}

export type ResendTokenResponse = boolean;

export const resendTokenConfirmation = async (
  payload: ResendTokenPayload
): Promise<ApiSuccessResponse<ResendTokenResponse>> => {
  const response = await httpClient.post<ApiSuccessResponse<ResendTokenResponse>>(
    `${USER_ACCESS_BASE_ROUTE}/token/resend-by-user-guid`,
    payload
  );
  return response.data;
};